export const hasPermission = (permissions, user) => {
    if (permissions) {
        if (!user.permissions || user.permissions.filter(p => permissions.includes(p)).length === 0) {
            return false
        }
    }
    return true
}
